import React, { Component } from "react";
import Festivos from "../../../components/Festivos/Festivos";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CardForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina – Se llama al componente Card
================================================================================ */
class FestivosForm extends Component{
    render(){
        return(
            <Festivos/>  
        )
    }
}

export default FestivosForm;